module.exports = __webpack_public_path__ + "static/media/1.0606a624.png";